import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/service';

/**
 * Blocks features that belong to entity/partner permissions only
 * (e.g. Merchants Portfolio, Settings Equipments catalog) when the session
 * has a restricted `merchantPermissions` list from merchant login.
 */
export const EntityOnlyFeatureGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.merchantPermissions.length) {
    return router.createUrlTree(['/miscellaneous/error'], {
      queryParams: { code: 403 },
    });
  }

  return true;
};
